import React from 'react';
import {useField, useFormikContext} from 'formik';

import {Column} from '../layout';
import ErrorMessage from './ErrorMessage';
import './styles.scss';
import AppSelectInput from '../input/app-select-input';

interface Option {
  value: string;
  label: string;
}

interface AppFormSelectFieldProps extends React.HTMLProps<HTMLInputElement> {
  name: string;
  showErrorMessage?: boolean;
  options: Option[];
  placeholder?: string;
  className?: string;
  handleFormikContext?(formik: any): void;
  inputStyle?: any;
  onChange?(value: any): void;
  error?: string;
  value?: any;
  defaultValue?: any;
}

function AppFormSelectField({
  name,
  showErrorMessage = false,
  options,
  placeholder,
  handleFormikContext,
  className,
  inputStyle,
  onChange,
  error,
  value,
  defaultValue,
}: AppFormSelectFieldProps) {
  const formik = useFormikContext();
  const {
    setFieldTouched,
    setFieldError,
    errors,
    touched,
    setFieldValue,
    handleChange,
  } = formik;
  const newError = error ? error : (errors as any)[name];
  const visible = (touched as any)[name];

  const [field] = useField(name);

  if (!!handleFormikContext) {
    handleFormikContext(formik);
  }

  return (
    <Column style={{width: '100%'}}>
      <AppSelectInput
        defaultValue={defaultValue || ''}
        inputStyle={inputStyle}
        className={className}
        onBlur={() => setFieldTouched(name)}
        placeholder={placeholder}
        value={value ? value : field.value}
        options={options}
        onChange={
          onChange
            ? (value) => {
                onChange(value);
                setFieldError(name, ''); // this might not be the best solution since it might affect other forms that use this component
                setFieldValue(name, value);
              }
            : (value) => {
                setFieldError(name, ''); // this might not be the best solution since it might affect other forms that use this component
                setFieldValue(name, value);
              }
        }
        error={error ? newError : newError && visible}
      />
      {showErrorMessage && <ErrorMessage error={newError} visible={visible} />}
    </Column>
  );
}

export default AppFormSelectField;
